/**
 * Disable the resend link until this much time
 */
export const RESEND_TIMEOUT = 10000;

/**
 * Copy shown when a code resend fails or stalls. screens/rewards/RewardsVerificationScreen
 * still keeps its own copy of this string.
 */
export const RESEND_ERROR_MESSAGE = 'Could not resend code. Try again.';

/**
 * Wait for [delay] ms if [promise] returns first, but only when the resend
 * succeeded. A failure settles at once so its error shows at once (DIS-1763).
 * @param promise
 * @param delay
 * @returns
 */
export async function slowDown(
  promise: Promise<boolean>,
  delay: number = RESEND_TIMEOUT,
): Promise<boolean> {
  const startedAt = Date.now();
  const value = await promise;

  if (value === true) {
    const remaining = delay - (Date.now() - startedAt);
    if (remaining > 0) {
      await new Promise(resolve => setTimeout(resolve, remaining));
    }
  }

  return value;
}
